import { useEffect, useState } from 'react'

import RugbyHeader from '../../components/header/rugby-header'

import './players.css'
import axios from 'axios';

const srcpath = "http://localhost:3000/rugbyplayerscard"

function PlayerBio() {
    const [articles, setArticles] = useState([]);
    useEffect(() => {
        axios
            .get(srcpath)
            .then(data => {
                setArticles(data.data)
            })
    }, []);

    return (
        <>
            <RugbyHeader />
            <div className='players'>
                <div className='container players-container'>
                    <div className='players-banner'>
                        <div className="back"> {'<'} Team </div>
                        <img className='player-photo' src={articles.filter((article) => article.playersrc === article.current)} alt="player-photo" />
                    </div>
                    <div className="players-biography">
                        <div className="players-biography__title">BIOGRAPHY</div>
                        <div className="players-biography__descr"></div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PlayerBio